module.exports = __webpack_public_path__ + "img/pr-2.e39101fb.png";